import { ReactNode } from 'react';

interface Props {
  nearbyList: Record<string, any>[];
  title: string;
  icon: ReactNode;
}

const NearbyItem = ({ nearbyList, title, icon }: Props) => {
  return (
    <div className='w-full'>
      <h3 className='mt-0'>
        <span className='inline-block ml-1'>{icon}</span>
        {title}
      </h3>
      <ul className='grid grid-cols-1 sm:grid-cols-3'>
        {nearbyList.map((item, index) => (
          <li key={item.distance + index}>{item.name} ({item.distance} متر)</li>
        ))}
      </ul>
    </div>
  );
};

export default NearbyItem;
